

export const GuatebusPage = () => {
  return (
    <div>GuatebusPage</div>
  )
}
